interface Props {
  content: string;
}

export const EstimatorInfoTooltip: React.FC<Props> = ({ content }) => (
  <div className="relative z-20 group/tooltip">
    <button
      aria-label={content}
      className="flex h-5 w-5 items-center justify-center rounded-full border border-white/10 bg-[#261533] text-[11px] font-semibold text-primary transition-colors duration-200 hover:border-primary/70 focus:border-primary/70 focus:outline-none"
      type="button">
      i
    </button>
    <div className="pointer-events-none absolute -right-10 md:right:0 top-8 md:top-0 z-30 w-96 max-w-[90vw] md:max-w-[unset] translate-y-2 rounded-[18px] border border-white/10 bg-[#21172d] px-6 py-5 text-left text-md leading-7 text-white opacity-0 invisible shadow-[0_12px_40px_rgba(0,0,0,0.35)] transition-all duration-300 group-hover/tooltip:visible group-hover/tooltip:translate-y-0 group-hover/tooltip:opacity-100 group-focus-within/tooltip:visible group-focus-within/tooltip:translate-y-0 group-focus-within/tooltip:opacity-100">
      <span className="font-normal tracking-normal">{content}</span>
    </div>
  </div>
);
